export default __webpack_public_path__ + "img/DhgUmkYQ.07526ac1.svg";